module.exports = __webpack_public_path__ + "img/SFAV_logo.a06d8f4c.jpeg";